<template>
  <div class="merge-field-selection__form">
    <div
      v-for="(tag, tagIndex) in mergeFieldTags"
      :key="tagIndex">
      <VGrid>
        <div slot="gridItem" type="7">
          <b>{{ tag }}</b>
        </div>
        <div slot="gridItem" type="5">
          <VInput
            type="textarea"
            size="small"
            v-model="mergeFieldTagsContent[tag]"
            @input="updateContent"
            data-ec="envelope_send"
            data-et="merge_field_input"
          />
        </div>
      </VGrid>
    </div>
  </div>
</template>

<script>
import VInput from '@/components/deprecated/atoms/Input.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';

export default {
  name: 'VMergeFieldSelection',
  components: {
    VInput,
    VGrid,
  },
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    mergeFieldTagsContent: {},
  }),
  computed: {
    fields() {
      return this.documents.flatMap(document => document.fields);
    },
    mergeFieldTags() {
      const allTags = this.fields
        .map(field => field.merge_field)
        .filter(tag => tag);

      return Array.from(new Set(allTags));
    },
  },
  methods: {
    updateContent() {
      const newFields = this.fields.map((field) => {
        const newField = { ...field };
        const mergeFieldContent = this.mergeFieldTagsContent[field.merge_field];
        newField.content = mergeFieldContent;

        return newField;
      });

      this.$emit('input', newFields);
    },
  },
};
</script>

<style scoped>
.merge-field-selection__form {
  padding: var(--spacing-base);
  background: #fff;
  border: 1px solid var(--color-border);
  border-top: 0;
}
.merge-field-selection__form:after {
  content: '';
  display: block;
  clear: both;
}
</style>
